<template>
    <table class="cart-table__table">
        <thead class="cart-table__head">
            <tr class="cart-table__row">
                <th class="cart-table__column cart-table__column--image">Item Number</th>
                <th class="cart-table__column cart-table__column--numeral">Quantity</th>
                <th class="cart-table__column cart-table__column--product"></th>
                <!-- <th class="cart-table__column cart-table__column--numeral"></th> -->
                <th class="cart-table__column cart-table__column--numeral"></th>
                <th class="cart-table__column cart-table__column--numeral"></th>
                <th class="cart-table__column cart-table__column--numeral"></th>
                <th class="cart-table__column cart-table__column--remove"><img src="images/spacer.png" width="20px" /></th>
            </tr>
        </thead>
        <tbody class="cart-table__body">
            <list-item v-for="(part, index) in parts"
                :ref="setItemRef"
                :key="index"
                :part="part"
                :index="index"
                :locations="locations"
                @update_qty="update_qty"
                @update_item_code="changeItemCode"
                @update_mfg_code="changeMFGCode"
                @update_reason="changeItemReason"
                @remove_item="remove_item"
            >
            </list-item>
        </tbody>
        <tfoot class="cart-table__foot">
            <tr>
                <td colspan="12">
                    <div class="cart-table__actions">
                        <div class="form-row">
                            <div class="form-group">
                                <p></p>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="checkout-first-name">Your Email</label>
                                <input type="text" class="form-control" id="checkout-billing-first-name" placeholder="" v-model="email" @change="$emit('update_email', email)"/>
                            </div>
                            <div class="form-group col-md-5">
                                <label for="checkout-last-name">Purchase Order #</label>
                                <input type="text" class="form-control" id="checkout-billing-last-name" placeholder="" v-model="retPO" @change="$emit('update_po', retPO)" />
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td colspan="6">
                    <div class="cart-table__actions">
                        <div class="cart-table__update-button cart-table__actions-stock-order-add-to-cart">
                            <button class="btn btn-md btn-checkout" @click="submit">Submit Return Request</button>
                        </div>
                    </div>
                </td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import ListItem from  "./ListItem.vue";
import axiosvl from "../../../axios/axios-vl.js";

export default {
    components: {ListItem},
    data(){
        return {
            email: '',

            parts: [],
            minRow : 5,
        }
    },
    methods: {
        expand() {
            this.parts.push({
                    item : '',
                    quantity : 0,
                    manufacturer : '',
                    isValid: '',
                    item_validation: '',
                    RSREAS: '',

                    QCORE: '',
                    QCOREN: '',
                    QAPRVD: '',
                    QEXTPRC: '',
                    QITEMSZ: '',
                    QOHAND: '',
                    QSELL: '',
                    QSCOREN: '',
                    QSIZE: '',
                    QTDESC: '',
                    SLOCN: '',
                    SPARTSL: '',
                    SPNUM: '',
                    QLIST: '',
                    XRITMC: '',
                    XRMFGC: '',
                });
        },

        blankParts() {
            this.parts = [];
            const rows = this.minRow;
            for(let i = 1; i <= rows; i++){
                this.parts.push({
                    item : '',
                    quantity : 0,
                    manufacturer : '',
                    isValid: '',
                    item_validation: '',
                    RSREAS: '',

                    QCORE: '',
                    QCOREN: '',
                    QAPRVD: '',
                    QEXTPRC: '',
                    QITEMSZ: '',
                    QOHAND: '',
                    QSELL: '',
                    QSCOREN: '',
                    QSIZE: '',
                    QTDESC: '',
                    SLOCN: '',
                    SPARTSL: '',
                    SPNUM: '',
                    QLIST: '',
                    XRITMC: '',
                    XRMFGC: '',
                });
            }
        },

        /**
         * submit web service
         */
        submit() {
            this.isloading = true;
            this.servermessages = [];
            const paramParts = [];
            
            this.parts.forEach(p => {
                if(p.item != null && p.item != ''){
                    paramParts.push([
                        p.item,
                        p.quantity,
                        p.manufacturer,
                        p.RSREAS,
                    ]);
                } 
            });
            console.log(this.parts);
            console.log(paramParts);
            
            const return_nonrma_submit_uri = this.$store.getters['api/return_nonrma_submit_uri'];
            console.log(return_nonrma_submit_uri);
            axiosvl.post(return_nonrma_submit_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                        },
                        "lists": {
                            "RPARTSNONRMA": {
                                "header": [
                                    {"name": "QITEMO"},
                                    {"name": "QIOQTY"},
                                    {"name": "QMFRO"},
                                    {"name": "RSREAS"}
                                ],
                                "entries": paramParts
                            }
                        }
                    }
                }
            )
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const SPARTS = response.data.webroutine.lists.SPARTS.entries;
                const RESULTCOD = fields.RESULTCOD.value;
                const val_parts = [];
                const messages = [];
                // let hasInvalid = false;
                
                for (const key in SPARTS) {
                    const obj = SPARTS[key];
                    console.log(obj);
                    val_parts.push({
                        ID        : obj.QITEMO,
                        item      : obj.QITEMO,
                        desc      : obj.QITDSC,
                        manufacturer: obj.QMFRO,
                        isValid: (obj.ITEMERR == "NOITEM") ? 'N' : 'Y',
                        quantity: obj.QIOQTY,
                        item_validation: obj.QITEMO + ' ' + obj.MCNAME + ' ' + obj.QITDSC,
                        MCNAME: obj.MCNAME,
                        RSREAS: this.parts[key].RSREAS,

                        QCORE: obj.QCORE,
                        QCOREN: obj.QCOREN,
                        QAPRVD: obj.QAPRVD,
                        QEXTPRC: obj.QEXTPRC,
                        QITEMSZ: obj.QITEMSZ,
                        QOHAND: obj.QOHAND,
                        QSELL: obj.QSELL,
                        QSCOREN: obj.QSCOREN,
                        QSIZE: obj.QSIZE,
                        QTDESC: obj.QTDESC,
                        SLOCN: obj.SLOCN,
                        SPARTSL: obj.SPARTSL,
                        SPNUM: obj.SPNUM,
                        QLIST: obj.QLIST,
                        XRITMC: obj.XRITMC,
                        XRMFGC: obj.XRMFGC,
                    });
                }

                this.parts = val_parts;

                this.savedResp = {
                    title: 'Return Submitted',
                    show: true,
                    message:  "Your returns request has been received.  Please contact Customer Service for further inquiries on your returns."
                }
                
                if(RESULTCOD == 'OK'){
                    this.savedResp = {
                        title: 'Return Submitted',
                        show: true,
                        message:  "Your returns request has been received.  Please contact Customer Service for further inquiries on your returns."
                    }
                }else{
                    const wrmessages = response.data.webroutine.messages;
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }

                    this.savedResp = {
                        title: 'Return Submitted Failed',
                        show: true,
                        message: fields.MSGTXT.value
                    }
                }

                this.$emit('submitted', this.savedResp);

                this.servermessages = messages;
                this.hasValidated = true;

                // console.table(val_parts);
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        update_qty(index, newQty){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.quantity = newQty;
                }
            });
            console.log(this.parts);
        },

        changeItemCode(index, newVal){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.item = newVal;
                    part.isValid = '';
                }
            });
            console.log(this.parts);
        },

        changeItemReason(index, newVal){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.RSREAS = newVal;
                    part.isValid = '';
                }
            });
            console.log(this.parts);
        },

        changeMFGCode(index, newVal){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.manufacturer = newVal;
                    part.isValid = '';
                }
            });
            console.log(this.parts);
        },
    },
    created() {
        this.blankParts();
    },
    mounted() {
        this.email = this.$store.getters['cart/email'].toLowerCase();
    }
}
</script>